/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Variant_SkuInputs */

const vi_shop_variant_sku = /** @type {(inputs: Shop_Variant_SkuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SKU ERP · tồn · giá`)
};

/**

* @param {Shop_Variant_SkuInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_variant_sku = /** @type {((inputs?: Shop_Variant_SkuInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Variant_SkuInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_variant_sku(inputs)
});